import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";

import UserSidebar from "../components/user/UserSidebar";
import UserHeader from "../components/user/UserHeader";

import "./UserDashboard.css";

function UserDashboard() {

  const navigate = useNavigate();

  const [name, setName] = useState("Student");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {

    const username = Cookies.get("username");

    if (username) {
      setName(username);
    }

  }, []);

  return (
    <div className="user-dashboard">

      {/* =====================================================
          SIDEBAR
      ====================================================== */}

      <UserSidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />


      {/* =====================================================
          MAIN CONTENT
      ====================================================== */}

      <main className="dashboard-main">

        {/* HEADER */}

        <UserHeader
          name={name}
          setSidebarOpen={setSidebarOpen}
        />


        {/* =====================================================
            DASHBOARD CONTENT
        ====================================================== */}

        <div className="dashboard-content">


          {/* =====================================================
              WELCOME SECTION
          ====================================================== */}

          <section className="welcome-section">

            <div className="welcome-text">

              <span className="welcome-badge">
                <i className="bi bi-stars"></i>
                HOMOEOADDA
              </span>

              <h1>
                Welcome back, {name}! 👋
              </h1>

              <p>
                Continue your preparation and become
                one step closer to your medical career.
              </p>

            </div>


            <div className="welcome-illustration">

              <i className="bi bi-mortarboard-fill"></i>

            </div>

          </section>


          {/* =====================================================
              PRACTICE MCQ SECTION
          ====================================================== */}

          <section className="section-block">

            <div className="section-heading">

              <div>
                <h2>Practice MCQs</h2>

                <p>
                  Strengthen your concepts with targeted practice.
                </p>
              </div>

              <Link to="/free-mcq">
                View All
                <i className="bi bi-arrow-right ms-2"></i>
              </Link>

            </div>


            {/* MCQ GRID */}

            <div className="mcq-grid">


              {/* =================================================
                  FREE MCQ
              ================================================== */}

              <div className="mcq-card free-card">

                <div className="mcq-card-top">

                  <div className="mcq-icon">

                    <i className="bi bi-journal-text"></i>

                  </div>

                  <span className="free-badge">
                    FREE
                  </span>

                </div>


                <h3>
                  Free MCQ Practice
                </h3>


                <p>
                  Practice important medical questions
                  and improve your preparation.
                </p>


                <div className="mcq-details">

                  <span>
                    <i className="bi bi-question-circle"></i>
                    500+ Questions
                  </span>

                  <span>
                    <i className="bi bi-clock"></i>
                    Practice Anytime
                  </span>

                </div>


                <Link
                  to="/free-mcq"
                  className="mcq-btn free-btn"
                >
                  Start Practice

                  <i className="bi bi-arrow-right"></i>

                </Link>

              </div>


              {/* =================================================
                  PREMIUM MCQ
              ================================================== */}

              <div className="mcq-card premium-card">

                <div className="premium-glow"></div>


                <div className="mcq-card-top">

                  <div className="mcq-icon premium-icon-bg">

                    <i className="bi bi-gem"></i>

                  </div>

                  <span className="premium-badge">
                    PREMIUM
                  </span>

                </div>


                <h3>
                  Premium MCQ Library
                </h3>


                <p>
                  Access high-quality exam-oriented
                  questions prepared by experts.
                </p>


                <div className="mcq-details">

                  <span>
                    <i className="bi bi-stars"></i>
                    10,000+ Questions
                  </span>

                  <span>
                    <i className="bi bi-graph-up"></i>
                    Detailed Analysis
                  </span>

                </div>


                <Link
                  to="/premium-mcq"
                  className="mcq-btn premium-btn"
                >
                  Explore Premium

                  <i className="bi bi-arrow-right"></i>

                </Link>

              </div>

            </div>

          </section>


          {/* =====================================================
              LOWER GRID
          ====================================================== */}

          <section className="dashboard-lower">


            {/* =================================================
                QUICK ACTIONS
            ================================================== */}

            <div className="quick-actions">

              <div className="section-heading">

                <div>

                  <h2>
                    Quick Actions
                  </h2>

                  <p>
                    Continue your preparation
                  </p>

                </div>

              </div>


              {/* QUICK PRACTICE */}

              <Link
                to="/free-mcq"
                className="quick-action"
              >

                <div className="quick-icon blue">

                  <i className="bi bi-lightning-fill"></i>

                </div>


                <div className="quick-action-content">

                  <strong>
                    Quick Practice
                  </strong>

                  <span>
                    Start 10 random MCQs
                  </span>

                </div>


                <i className="bi bi-chevron-right quick-arrow"></i>

              </Link>


              {/* PREMIUM PRACTICE */}

              <Link
                to="/premium-mcq"
                className="quick-action"
              >

                <div className="quick-icon purple">

                  <i className="bi bi-gem"></i>

                </div>


                <div className="quick-action-content">

                  <strong>
                    Premium Practice
                  </strong>

                  <span>
                    Expert level MCQs
                  </span>

                </div>


                <i className="bi bi-chevron-right quick-arrow"></i>

              </Link>


              {/* PERFORMANCE */}

              <Link
                to="/results"
                className="quick-action"
              >

                <div className="quick-icon green">

                  <i className="bi bi-bar-chart-fill"></i>

                </div>


                <div className="quick-action-content">

                  <strong>
                    View Performance
                  </strong>

                  <span>
                    Check your progress
                  </span>

                </div>


                <i className="bi bi-chevron-right quick-arrow"></i>

              </Link>

            </div>

          </section>


          {/* =====================================================
              PREMIUM BANNER
          ====================================================== */}

          <section className="premium-banner">


            <div className="premium-banner-content">

              <span>

                <i className="bi bi-stars"></i>

                HOMOEOADDA PREMIUM

              </span>


              <h2>
                Unlock your full preparation potential.
              </h2>


              <p>
                Get unlimited access to premium MCQs,
                mock tests, detailed solutions and performance analysis.
              </p>


              <button
                type="button"
                onClick={() => navigate("/subscription")}
              >
                Upgrade to Premium

                <i className="bi bi-arrow-right ms-2"></i>

              </button>

            </div>


            <div className="premium-banner-icon">

              <i className="bi bi-gem"></i>

            </div>

          </section>


        </div>

      </main>

    </div>
  );
}

export default UserDashboard;